import type { Gender, KarteTopic2 } from '@/gql/graphql';

type Address = {
  prefecture: string;
  city: string;
  town: string;
  jisx0402: string;
};
export const DIAGNOSIS_VERSION = 'V20240229';
export type Answers = {
  gender: Nullable<Gender>;
  jobId: Nullable<string>;
  postalCode: Nullable<string>;
  address: Nullable<Address>;
  birthday: Nullable<string>;
  annualIncome: Nullable<string>;
  savings: Nullable<string>;
  monthlySavings: Nullable<string>;
  investment: Nullable<string>;
  hasPartner: Nullable<boolean>;
  partnerBirthday: Nullable<string>;
  partnerAnnualIncome: Nullable<string>;
  hasChild: Nullable<boolean>;
  countOfChildren: Nullable<1 | 2 | 3 | 4 | 5>;
  firstChildBirthDay: Nullable<string>;
  secondChildBirthDay: Nullable<string>;
  thirdChildBirthDay: Nullable<string>;
  fourthChildBirthDay: Nullable<string>;
  fifthChildBirthDay: Nullable<string>;
  firstChildGender: Nullable<Gender>;
  secondChildGender: Nullable<Gender>;
  thirdChildGender: Nullable<Gender>;
  fourthChildGender: Nullable<Gender>;
  fifthChildGender: Nullable<Gender>;
  monthlyRentCost: Nullable<string>;
  loanBalance: Nullable<string>;
  monthlyInsurance: Nullable<string>;
  thinksToughTimesBringOpportunity: Nullable<boolean>;
  thinksWhatDoneIsDone: Nullable<boolean>;
  isInterestedInNisaOrIdeco: Nullable<boolean>;
  hasGoalInFuture: Nullable<boolean>;
  takesThreeOrMoreLessons: Nullable<boolean>;
  followsTheLatestTrends: Nullable<boolean>;
  karteTopics: Nullable<KarteTopic2[]>;
  karteComment: Nullable<string>;
};
export type QuestionKey = keyof Answers;

export const createInitialAnswers = (): Answers => ({
  // 質問の順番に並べること！
  gender: null,
  jobId: null,
  postalCode: null,
  address: null,
  birthday: null,
  annualIncome: null,
  savings: null,
  monthlySavings: null,
  investment: null,
  hasPartner: null,
  partnerBirthday: null,
  partnerAnnualIncome: null,
  hasChild: null,
  countOfChildren: null,
  firstChildBirthDay: null,
  secondChildBirthDay: null,
  thirdChildBirthDay: null,
  fourthChildBirthDay: null,
  fifthChildBirthDay: null,
  firstChildGender: null,
  secondChildGender: null,
  thirdChildGender: null,
  fourthChildGender: null,
  fifthChildGender: null,
  monthlyRentCost: null,
  loanBalance: null,
  monthlyInsurance: null,
  thinksToughTimesBringOpportunity: null,
  thinksWhatDoneIsDone: null,
  isInterestedInNisaOrIdeco: null,
  hasGoalInFuture: null,
  takesThreeOrMoreLessons: null,
  followsTheLatestTrends: null,
  karteTopics: null,
  karteComment: null,
});

export const questionOrder: QuestionKey[] = Object.keys(
  createInitialAnswers()
) as unknown as QuestionKey[];

export function sortByQuestionOrder(items: QuestionKey[]): QuestionKey[] {
  return items.sort((a, b) => {
    return questionOrder.indexOf(a) - questionOrder.indexOf(b);
  });
}
